import { type FC, type ReactNode } from "react";

import { LegalAuthoritySidebar } from "./LegalAuthoritySidebar";
import { ModalStepLayout } from "./ModalStepLayout";

interface LegalAuthorityStepLayoutProps {
  title: string;
  titleTooltip?: { title?: string; content: string };
  description?: string;
  activeStep: 1 | 2 | 3;
  onBack?: () => void;
  footerLeft?: ReactNode;
  actionButton?: ReactNode;
  children: ReactNode;
}

export const LegalAuthorityStepLayout: FC<LegalAuthorityStepLayoutProps> = ({
  title,
  titleTooltip,
  description,
  activeStep,
  onBack,
  footerLeft,
  actionButton,
  children,
}) => (
  <ModalStepLayout
    sidebar={<LegalAuthoritySidebar activeStep={activeStep} />}
    title={title}
    titleTooltip={titleTooltip}
    description={description}
    onBack={onBack}
    footerLeft={footerLeft}
    actionButton={actionButton}
  >
    {children}
  </ModalStepLayout>
);
